export const CHART_TRANSLATION = {
  CHART_SETTINGS: {
    key: 'CHART_SETTINGS',
    value: 'Chart Settings',
  },
  LABEL: {
    key: 'LABEL',
    value: 'Label',
  },
  NAME_LABEL: {
    key: 'NAME_LABEL',
    value: 'Name',
  },
  VALUE_LABEL: {
    key: 'VALUE_LABEL',
    value: 'Value',
  },
  DESC_LABEL: {
    key: 'DESC_LABEL',
    value: 'Desc',
  },
  SERIES_NAME_LABEL: {
    key: 'SERIES_NAME_LABEL',
    value: 'Series Name',
  },
  SERIES_VALUE_LABEL: {
    key: 'SERIES_VALUE_LABEL',
    value: 'Series Value',
  },
  LEGEND_LABEL: {
    key: 'LEGEND_LABEL',
    value: 'Legend',
  },
  DESCRIPTION_LABEL: {
    key: 'DESCRIPTION_LABEL',
    value: 'Description',
  },
  DATA_LABEL: {
    key: 'DATA_LABEL',
    value: 'Data',
  },
  SETTINGS_LABEL: {
    key: 'SETTINGS_LABEL',
    value: 'Settings',
  },
  GENERAL_LABEL: {
    key: 'GENERAL_LABEL',
    value: 'general',
  },
  FONTSTYLES_LABEL: {
    key: 'FONTSTYLES_LABEL',
    value: 'font styles',
  },
  CHART_TYPE_LABEL: {
    key: 'CHART_TYPE_LABEL',
    value: 'chart type',
  },
  CHART_STYLE_LABEL: {
    key: 'CHART_STYLE_LABEL',
    value: 'chart style',
  },
  DELETE_ROW_LABEL: {
    key: 'DELETE_ROW_LABEL',
    value: 'Delete Row',
  },
  ADD_ROW_LABEL: {
    key: 'ADD_ROW_LABEL',
    value: 'Add Row',
  },
  ADD_COLUMN_LABEL: {
    key: 'ADD_COLUMN_LABEL',
    value: 'Add Column',
  },
  MORE_LABEL: {
    key: 'MORE_LABEL',
    value: 'More',
  },
  INSERT_BEFORE_LABEL: {
    key: 'INSERT_BEFORE_LABEL',
    value: 'Insert row before',
  },
  INSERT_AFTER_LABEL: {
    key: 'INSERT_AFTER_LABEL',
    value: 'Insert row after',
  },
  DYNAMIC_CHART_QUESTION: {
    key: 'DYNAMIC_CHART_QUESTION',
    value: 'Do you want dynamic charts to be generated?',
  },
  FONT_SIZE_TOOLTIP: {
    key: 'FONT_SIZE_TOOLTIP',
    value: 'Font Size',
  },
  FONT_COLOR_TOOLTIP: {
    key: 'FONT_COLOR_TOOLTIP',
    value: 'Font Color',
  },
  SELECT_A_VARIABLE: {
    key: 'SELECT_A_VARIABLE',
    value: 'Select a variable',
  },
  FORMAT_VALUES_AT: {
    key: 'FORMAT_VALUES_AT',
    value: 'Format values as',
  },
  PERCENTAGES_LABEL: {
    key: 'PERCENTAGES_LABEL',
    value: 'Percentages',
  },
  NUMBERS_LABEL: {
    key: 'NUMBERS_LABEL',
    value: 'Numbers',
  },
  SHOW_LEGEND_LABEL: {
    key: 'SHOW_LEGEND_LABEL',
    value: 'Show legend',
  },
  SHOW_GRID_LABEL: {
    key: 'SHOW_GRID_LABEL',
    value: 'Show grid',
  },
  INTERVAL_LABEL: {
    key: 'INTERVAL_LABEL',
    value: 'Value interval',
  },
  FORMAT_VALUES_LABEL: {
    key: 'FORMAT_VALUES_LABEL',
    value: 'Format values',
  },
  SHOW_LABELS_LABEL: {
    key: 'SHOW_LABELS_LABEL',
    value: 'Show labels',
  },
  ORIENTATION_LABEL: {
    key: 'ORIENTATION_LABEL',
    value: 'Orientation',
  },
  LEGEND_POSITION_LABEL: {
    key: 'LEGEND_POSITION_LABEL',
    value: 'Legend position',
  },
  TOP_LABEL: {
    key: 'TOP_LABEL',
    value: 'Top',
  },
  BOTTOM_LABEL: {
    key: 'BOTTOM_LABEL',
    value: 'Bottom',
  },
  LEFT_LABEL: {
    key: 'LEFT_LABEL',
    value: 'Left',
  },
  RIGHT_LABEL: {
    key: 'RIGHT_LABEL',
    value: 'Right',
  },
  HORIZONTAL_LABEL: {
    key: 'HORIZONTAL_LABEL',
    value: 'Horizontal',
  },
  VERTICAL_LABEL: {
    key: 'VERTICAL_LABEL',
    value: 'Vertical',
  },
  PIE_LABEL: {
    key: 'PIE_LABEL',
    value: 'Pie',
  },
  DONUT_LABEL: {
    key: 'DONUT_LABEL',
    value: 'Donut',
  },
  LINE_LABEL: {
    key: 'LINE_LABEL',
    value: 'Line',
  },
  BAR_LABEL: {
    key: 'BAR_LABEL',
    value: 'Bar',
  },
  PIE_WITH_CALLOUT: {
    key: 'PIE_WITH_CALLOUT',
    value: 'Pie with Call out',
  },
  DONUT_WITH_CALLOUT: {
    key: 'DONUT_WITH_CALLOUT',
    value: 'Donut with Call out',
  },
  LABEL_VALUE_INSIDE: {
    key: 'LABEL_VALUE_INSIDE',
    value: 'Label/value Inside',
  },
  LABEL_VALUE_OUTSIDE: {
    key: 'LABEL_VALUE_OUTSIDE',
    value: 'Label/value Outside',
  },
  NORMAL_LABEL: {
    key: 'NORMAL_LABEL',
    value: 'Normal',
  },
  SMOOTH_LABEL: {
    key: 'SMOOTH_LABEL',
    value: 'Smooth',
  },
  INFOGRAPHIC_LABEL: {
    key: 'INFOGRAPHIC_LABEL',
    value: 'Infographic',
  },
  DESC_WITH_VALUE: {
    key: 'DESC_WITH_VALUE',
    value: 'Label, Desc with Value',
  },
  VALUE_INSIDE: {
    key: 'VALUE_INSIDE',
    value: 'Display Value Inside',
  },
  CHART_UPDATE_ERROR: {
    key: 'CHART_UPDATE_ERROR',
    value: 'Error updating the chart',
  },
  CHART_PREVIEW_GENERATE: {
    key: 'CHART_PREVIEW_GENERATE',
    value: 'Generating chart preview',
  },
  SPECIAL_CHAR_ERROR: {
    key: 'SPECIAL_CHAR_ERROR',
    value: 'Variable name cannot contain any special characters or spaces other than hyphen(-)'
  }
};
